import React, { useState } from 'react';
import styles from './PageTile.styles.scss';
import cn from 'classnames';
import { Button } from 'primereact/button';

const PageTile = ({
  title,
  description,
  iconName,
  handleClick,
  disabled,
  onHover,
  hoverStyles,
  titleClassName,
  imageClassName,
}) => {
  let image;

  try {
    image = require(`../../assets/png/${iconName}.png`);
  } catch (e) {
    image = null;
  }

  const [hover, setIsHover] = useState(false);

  return (
    <Button
      text
      link
      className={cn(
        styles.container,
        hoverStyles() ? styles.hoveredContainer : '',
      )}
      onClick={handleClick}
      onKeyDown={(e) => {
        if (e.key === 'Enter' && !disabled) {
          handleClick();
        }
      }}
      disabled={disabled}
      onMouseOver={() => {
        setIsHover(true);
      }}
      onMouseLeave={() => {
        setIsHover(false);
      }}
      onFocus={() => {
        setIsHover(true);
      }}
      onBlur={() => {
        setIsHover(false);
      }}
    >
      <div
        className={cn(
          styles.icon,
          disabled ? styles.disabledIcon : '',
          styles.imageDiv,
        )}
      >
        <div className={styles.imgDivBg}>
          {image && <img className={imageClassName} src={image} alt="" />}
        </div>
      </div>
      <div className={cn(styles.titleDiv)}>
        <p
          className={cn(
            styles.title,
            disabled ? styles.disableTitle : '',
            titleClassName,
            hover ? styles.hoveredContainer : '',
          )}
        >
          {title}
        </p>
        <p
          className={cn(
            styles.description,
            disabled ? styles.disableTitle : '',
            titleClassName,
          )}
        >
          {description}
        </p>
      </div>
    </Button>
  );
};

export default React.memo(PageTile);
